// Imports for external libraries go here.
import React, { FC } from 'react';
import { Link, Modal } from '@marriott/mi-ui-library';
import clsx from 'clsx';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { LangNavList, LanguageSelectorProps } from './LanguageSelector.types';
import { StyledLanguageSelector, StyledModalHeader, StyledModalBody } from './LanguageSelector.styles';

// Use named rather than default exports.
export const LanguageSelector: FC<LanguageSelectorProps> = (props: LanguageSelectorProps) => {
  return (
    <StyledLanguageSelector
      data-testid="luxury-LanguageSelector"
      data-component-name="m-luxury-LanguageSelector"
      ref={props?.langSelectorRef}
    >
      <div className="language-selector">
        {props?.languageSelectorModal && props?.languageSelectorModal?.langNavList && props?.isOpen && (
          <Modal
            className="modal-popup-container"
            secondaryClassName="modal-main-container"
            show={props?.isOpen}
            popupOpenState={props?.isOpen}
            handleBlur={true}
            setPopupOpenState={props?.setIsOpen as () => void}
            disableScrollOnBody={true}
            role="dialog"
            aria-modal="true"
            aria-label="dialog"
          >
            <StyledModalHeader
              className="modal-header px-4 px-md-5 py-0"
              labelText={props?.languageSelectorModal?.languageSelectorTitle}
              popupHeaderOnCLoseFunc={props?.setIsOpen as () => void}
              popupCloseIconClassName="icon-l p-1"
              customHeadingClass="t-subtitle-l"
            ></StyledModalHeader>
            <StyledModalBody className="modal-body">
              <ul className="links-wrapper p-0 m-0 d-flex">
                {props?.languageSelectorModal?.langNavList.map((el: LangNavList, idx: number) => (
                  <li
                    className={clsx('col-12 col-md-6 link-item-wrapper', idx % 2 === 0 ? 'pr-md-4' : '')}
                    key={`${el?.languageLabel}_${idx}`}
                    id={`${el?.languageLabel}_${idx}`}
                  >
                    <Link
                      linkHref={el?.localePagePath}
                      linkClassName={clsx('custom_click_track t-label-s')}
                      custom_click_track_value={el?.clickTrackValue}
                      rel={el?.openInNewTab ? 'noopener noreferrer' : ''}
                      text={el?.languageLabel}
                      target={el.openInNewTab ? '_blank' : '_self'}
                      ariaLabel={el?.languageLabel}
                    />
                  </li>
                ))}
              </ul>
            </StyledModalBody>
          </Modal>
        )}
      </div>
    </StyledLanguageSelector>
  );
};
